<template>
    <div>
        <ad-url-icon :ad="ad"></ad-url-icon>

        <ad-content-icon :ad="ad"></ad-content-icon>

        <ad-dtp-comment-icon :ad="ad"></ad-dtp-comment-icon>
    </div>
</template>

<script>
    import AdContentIcon from '@/components/Icons/AdContentIcon'
    import AdDtpCommentIcon from '@/components/Icons/AdDtpCommentIcon'
    import AdUrlIcon from '@/components/Icons/AdUrlIcon'

    export default {
        components: {AdContentIcon, AdDtpCommentIcon, AdUrlIcon},

        props: {
            ad: {
                type: Object,
                required: true
            }
        }
    }
</script>
